import * as FingerprintJS from "../src";
import { rpaMD5Hashing } from "../src";

// const RPA_WORKER = "aHR0cHM6Ly8yNGhib25nZGEtdGVzdC52eDg4LndvcmtlcnMuZGV2Lw==";

// const HMACSHA256 = (stringToSign: String, secret: String) => "not_implemented";

async function getVisitorData() {
  const fp = await FingerprintJS.load({ debug: false });
  return await fp.get();
}

async function getIncognitoMode() {
  return await FingerprintJS.detectIncognito();
}

async function rpaVisitorIDGenerator(): Promise<void> {
  const startTime = Date.now();
  // Check local storage is emapty or not.
  let RPAVisitorID = window.localStorage.getItem("bi_rpa_vid") || "trashdevice";

  // Check if local storage don't have bi_rpa_hid set RPAVisitorID to trashdevice
  const RPAHashVisitorID = window.localStorage.getItem("bi_rpa_hid") || null;

  RPAVisitorID = RPAHashVisitorID ? RPAVisitorID : "trashdevice";

  // if RPA Vistior ID is trashdevice
  RPAVisitorID === "trashdevice" ? window.localStorage.setItem("bi_rpa_vid", "trashdevice") : null;

  try {
    const { visitorId, blendingValue, canvasTextValue, components } = await getVisitorData();
    const totalTime = Date.now() - startTime;

    const componentsEncodedHeaders = window.btoa(
      JSON.stringify({
        alg: "HS512",
        typ: "JWT",
      })
    );

    // Fingerprint encoding Source code
    const fullComponent = { components: JSON.stringify(components), incognitoMode: getIncognitoMode() };
    const componentStr = encodeURIComponent(JSON.stringify(fullComponent));
    const componentsEncodedPlayload = window.btoa(componentStr);
    const componentsSignature = "not_implemented";
    const componentsEncodedSignature = window.btoa(componentsSignature);
    const componentsJWT = `${componentsEncodedHeaders}.${componentsEncodedPlayload}.${componentsEncodedSignature}`;
    window.localStorage.setItem("bi_rpa_token", componentsJWT);

    const isGoogleBot = navigator.userAgent.includes("compatible") || navigator.userAgent.includes("Googlebot");

    if (isGoogleBot) {
      window.localStorage.setItem("bi_rpa_vid", "GoogleBot");
    }

    if (RPAVisitorID === "trashdevice" && !isGoogleBot) {
      if (FingerprintJS.isDesktopSafari() || FingerprintJS.isWebKit()) {
        /*
         * Compare Fingerprint ID.
         * On Mac Device Getting Some problem.
         * First time render getting A Key, Second time getting B Key.
         * B Key is the true key.
         * *** Solution:
         * Getting an array to save all generate key in same time.
         * Find out the most value key.
         */
        const key1 = await getVisitorData();
        const key2 = await getVisitorData();
        const key3 = await getVisitorData();
        const key4 = await getVisitorData();
        const key5 = await getVisitorData();

        const KEYARRAY = [
          `${key1.visitorId}@${key1.canvasTextValue}@${key1.blendingValue}`,
          `${key2.visitorId}@${key2.canvasTextValue}@${key2.blendingValue}`,
          `${key3.visitorId}@${key3.canvasTextValue}@${key3.blendingValue}`,
          `${key4.visitorId}@${key4.canvasTextValue}@${key4.blendingValue}`,
          `${key5.visitorId}@${key5.canvasTextValue}@${key5.blendingValue}`,
        ];

        const FILTEREDKEY = KEYARRAY.filter((v, i) => KEYARRAY.indexOf(v) !== i);
        const UNIQUEKEY = new Set(FILTEREDKEY);

        //  Save mostly key into local storage.
        window.localStorage.setItem("bi_rpa_vid", `${Array.from(UNIQUEKEY)[0]}`);
        //  Save Hash key into local storage.
        window.localStorage.setItem("bi_rpa_hid", rpaMD5Hashing.hashStr(`${Array.from(UNIQUEKEY)[0]}`, false));
        //  Save process time.
        sessionStorage.setItem("bi_rpa_vid_t", `${totalTime}`);
      } else {
        window.localStorage.setItem("bi_rpa_vid", `${visitorId}@${canvasTextValue}@${blendingValue}`);
        window.localStorage.setItem("bi_rpa_hid", rpaMD5Hashing.hashStr(`${visitorId}@${canvasTextValue}@${blendingValue}`, false));
      }
    }

    window.localStorage.setItem("bi_rpa_token", componentsJWT);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    // throw error
  }
}

rpaVisitorIDGenerator();
